import React, { ReactElement } from 'react';
import Text from './ui/text';

interface Props {
  title: string;
}

export default function GridPartialTitle({ title }: Props): ReactElement {
  return (
    <div className="col-span-full">
      <Text variant="mediumHeading" className="w-full lg:max-w-[66%] mt-4">
        {title}
      </Text>
    </div>
  );
}
